const Menus = [
	{
		id: 1,
		menu: 1,
		route: {
			id: 2,
			name: 'Dashboard',
			path: '/',
			icon: 'fas fa-bars',
		},
		parent: 0,
		ordinal: 0,
		itens: null,
		parentNode: null,
		internalId: null,
		color: '#007bff',
	},
	{
		id: 11,
		menu: 1,
		route: {
			id: 12,
			name: 'Indicadores',
			path: '/charts',
			icon: 'fas fa-chart-pie',
		},
		parent: 0,
		ordinal: 0,
		itens: null,
		parentNode: null,
		internalId: null,
		color: '#fd7e14',
	},
	{
		id: 21,
		menu: 1,
		route: {
			id: 22,
			name: 'Situação Limite',
			path: '/salesFrequency',
			icon: 'fas fa-chart-line',
		},
		parent: 0,
		ordinal: 0,
		itens: null,
		parentNode: null,
		internalId: null,
		color: '#ffc107',
	},
	{
		id: 22,
		menu: 1,
		route: {
			id: 23,
			name: 'Grid',
			path: '/salesFrequencyAtual',
			icon: 'fas fa-chart-line',
		},
		parent: 0,
		ordinal: 0,
		itens: null,
		parentNode: null,
		internalId: null,
		color: '#ff9807',
	},
	{
		id: 31,
		menu: 1,
		route: {
			id: 32,
			name: 'Clientes',
			path: '/customers',
			icon: 'fas fa-user-tie',
		},
		parent: 0,
		ordinal: 0,
		itens: null,
		parentNode: null,
		internalId: null,
		color: '#17a2b8',
	},
	{
		id: 41,
		menu: 1,
		route: {
			id: 42,
			name: 'Carteira',
			path: '/wallet',
			icon: 'fas fa-wallet',
		},
		parent: 0,
		ordinal: 0,
		itens: null,
		parentNode: null,
		internalId: null,
		color: '#28a745',
	},
	{
		id: 51,
		menu: 1,
		route: {
			id: 52,
			name: 'Faturado',
			path: '/billed',
			icon: 'fas fa-money-bill-wave',
		},
		parent: 0,
		ordinal: 0,
		itens: null,
		parentNode: null,
		internalId: null,
		color: '#17a2b8',
	},
	{
		id: 61,
		menu: 1,
		route: {
			id: 62,
			name: 'Dup. Aberto',
			path: '/duplicates',
			icon: 'fas fa-file-invoice-dollar',
		},
		parent: 0,
		ordinal: 0,
		itens: null,
		parentNode: null,
		internalId: null,
		color: '#20c997',
	},
	{
		id: 71,
		menu: 1,
		route: {
			id: 72,
			name: 'Ped. Cancelados',
			path: '/canceledOrders',
			icon: 'fas fa-file-excel',
			// "icon": "fas fa-strikethrough"
			// "icon": "fas fa-times"
			// "icon": "far fa-times-circle"
		},
		parent: 0,
		ordinal: 0,
		itens: null,
		parentNode: null,
		internalId: null,
		color: '#eb6134',
	},
	{
		id: 81,
		menu: 1,
		route: {
			id: 82,
			name: 'Desemp. Clientes',
			path: '/customerPerformance',
			icon: 'fas fa-chart-line',
			// "icon": "fas fa-strikethrough"
			// "icon": "fas fa-times"
			// "icon": "far fa-times-circle"
		},
		parent: 0,
		ordinal: 0,
		itens: null,
		parentNode: null,
		internalId: null,
		color: '#34ebbd',
	},
	{
		id: 91,
		menu: 1,
		route: {
			id: 92,
			name: 'Rotas',
			path: '/routes',
			icon: 'fas fa-route',
		},
		parent: 0,
		ordinal: 0,
		itens: null,
		parentNode: null,
		internalId: null,
		color: '#6d5b9c',
	},
];

export default Menus;
